import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Input from '../../general/Input/Input';
import Button from '../../general/Button/Button';
import { resetPassword } from '../../../store/actions/userActions';
import './LoginRegisterReset.css';  // Importando o CSS comum
import { validateEmail } from '../../../utils/ValidationLoginRegisterReset';
import Alert from '../../intern/Alert/Alert';  // Importando o componente de alerta

const ResetPassword = () => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [alertVisible, setAlertVisible] = useState(false);

    // Função de envio do formulário para recuperação de senha
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validação do e-mail
        const emailError = validateEmail(email);
        if (emailError) {
            setError(emailError);
            return;
        }

        dispatch(resetPassword({ email }))
        setError('');


        // Exibir o alerta de sucesso
        setAlertVisible(true);
    };

    // Função para fechar o alerta manualmente
    const closeAlert = () => {
        setAlertVisible(false);
    };

    return (
        <div className="containerMain">
            <div className="formContainer">

                <div className="textCenter">
                    <h1 className="heading">Recuperação de senha</h1>
                    <p className="subheading">Digite seu e-mail para receber um link de recuperação.</p>
                </div>

                <Helmet>
                    <title>Reset Password</title>
                </Helmet>

                <form onSubmit={handleSubmit}>
                    <div className="inputGroup">
                        <Input
                            type="email"
                            placeholder="example@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={error}
                        />
                        {error && <p className="errorText">{error}</p>}
                    </div>

                    <Button type="submit" className='btn-margin btn-primary' variant="primary" fullWidth>
                        Enviar e-mail
                    </Button>

                    <hr className="divider" />

                    <div className="textCenter">
                        <p className="text-gray-600">
                            Lembrou a senha?
                            <Link to="/" className="linkLogin">Voltar para o login</Link>
                        </p>
                    </div>
                </form>


                {alertVisible && (
                    <Alert
                        type="envio" // Tipo de alerta de sucesso
                        onClose={closeAlert} // Função para fechar o alerta
                    />
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
